import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=2fbf351a&"
import script from "./FooterBlock.js?vue&type=script&lang=js&"
export * from "./FooterBlock.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports